import { UserAdviceRole } from "../../Components/UserAdvice/Params"
import { IAppState } from "../../Types"
import { UserAdvice } from "./Advice"
import { AlertAdvice } from "./AlertAdvice"
import { AnchorMonitorAdvice } from "./AnchorMonitorAdvice"
import { DepthWatchAdvice } from "./DepthWatchAdvice"
import { EngineMissingAdvice } from "./EngineMissingAdvice"
import { ManualShipStatusAdvice } from "./ManualShipStatusAdvice"
import { StopUserAdvice } from "./StopAdvice"
import { LightsReminderAdvice } from "./LightsReminderAdvice"
import type { SettingsWriters } from "../../Data/SettingsWriters"

// Every advice the current-log row and day summary offer, in the order the old
// `UserAdvice.getAdvices()` returned them. It lives here rather than as a static on
// the base class (where it was before #1171) so `Advice.ts` never has to import its
// own subclasses -- each of them extends it.
export function getUserAdvices(app: Pick<IAppState, "hasFeature">, settingsWriters?: SettingsWriters): UserAdvice[] {
  return [new AlertAdvice(), new StopUserAdvice(), new EngineMissingAdvice(), new AnchorMonitorAdvice(), new DepthWatchAdvice(), ...(settingsWriters ? [new LightsReminderAdvice(settingsWriters)] : []), new ManualShipStatusAdvice()]
    .filter((advice) => advice.feature == undefined || app.hasFeature(advice.feature));
}

// The advices doing one particular job (#916), so a surface can offer just the
// ones it is for: the log row renders `alert` and `action`, the ship toolbar
// renders `monitor`.
//
// A filter over the one list above rather than a hand-maintained list per role,
// which would let an advice be registered under no role or under two -- and it is
// the flat list that fixes render order, which filtering preserves.
//
// `app` is threaded through rather than dropped so the feature gating in
// `getUserAdvices` still applies: filtering by role must not become a way to reach
// an advice its flag is meant to withhold.
export function userAdvicesByRole(app: Pick<IAppState, "hasFeature">, role: UserAdviceRole): UserAdvice[] {
  return getUserAdvices(app).filter((advice) => advice.role == role);
}
